exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SearchPage__title___qFw_M {\n  margin-bottom: 20px;\n}\n.SearchPage__input___3slXt {\n  max-width: 400px;\n}\n.SearchPage__briefings___AAVLM {\n  margin: -10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.SearchPage__results___-cHAf {\n  margin-top: 20px;\n}\n", ""]);
// Exports
exports.locals = {
	"title": "SearchPage__title___qFw_M",
	"input": "SearchPage__input___3slXt",
	"briefings": "SearchPage__briefings___AAVLM",
	"results": "SearchPage__results___-cHAf"
};